import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to clear profile tab state when navigating away from profile page
 */
export const useProfileTabCleanup = () => {
  const location = useLocation();

  useEffect(() => {
    const isProfilePage = location.pathname === '/profile';
    if (!isProfilePage) {
      localStorage.removeItem('profile_activeTab');
    }
  }, [location.pathname]);
};

